<template>
  <b-card-actions
    title="Income Tax"
    :amount="incomeTaxAmount"
    :currency="currency"
    :collapsed="true"
    action-collapse
  >

    <b-form>
      <b-row>
        <b-col
          cols="4"
          :class="{ 'disabled': payslip && payslip.status === 'finally_generated' }"
        >
          <h5 class="text-capitalize">
            Income Tax Amount Input
          </h5>
          <template>
            <div>
              <ValidationProvider
                v-slot="{ errors }"
                name="Tax amount"
                vid="tax_amount"
                rules="required|min:0"
              >
                <b-form-input
                  id="income_tax_amount"
                  v-model="incomeTaxAmount"
                  :state="errors.length > 0 ? false : null"
                  type="number"
                  :disabled="payslip?.status === 'finally_generated'"
                  placeholder="Tax deduction amount"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </ValidationProvider>
            </div>
          </template>
        </b-col>
        <b-col
          offset="5"
          cols="3"
        >
          <h5 class="text-capitalize">
            Income Tax Amount
          </h5>
          <template>
            <div>
              <b-form-input
                id="tax_deduction_amount"
                v-model="incomeTaxAmount"
                type="number"
                placeholder="Tax deduction amount"
                :disabled="true"
              />
            </div>
          </template>
        </b-col>
      </b-row>
    </b-form>

  </b-card-actions>
</template>

<script>
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import {
  BCol, BForm, BFormInput, BRow,
} from 'bootstrap-vue'
import { ValidationProvider } from 'vee-validate'
import Ripple from 'vue-ripple-directive'

export default {
  name: 'IncomeTaxInfo',
  components: {
    ValidationProvider,
    BFormInput,
    BForm,
    BRow,
    BCol,
    BCardActions,
  },
  directives: {
    Ripple,
  },
  props: {
    payslip: {
      type: Object,
      required: true,
    },
    currency: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      incomeTaxAmount: 0,
    }
  },
  watch: {
    incomeTaxAmount: {
      handler() {
        this.emitValue()
      },
      immediate: true, // Optional — add if you want `emitValue()` to run on component mount
    },
    payslip: {
      handler(newVal) {
        this.incomeTaxAmount = newVal.income_tax_amount
      },
      immediate: true,
    },
  },
  methods: {
    emitValue() {
      this.$emit('append-data', this.incomeTaxAmount)
    },
  },
}
</script>

<style scoped>
</style>
